import { render } from "./SiteCard.vue?vue&type=template&id=37f05b94&scoped=true"
import script from "./SiteCard.vue?vue&type=script&lang=js"
export * from "./SiteCard.vue?vue&type=script&lang=js"

import "./SiteCard.vue?vue&type=style&index=0&id=37f05b94&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37f05b94"]])

export default __exports__